import { inject } from 'vue'
import { t } from '@/libs/i18n'

export function useSaveStatus() {
  const statusMessage = inject('saveStatusMessage')
  const isSaving = inject('isSaving')
  const errors = inject('errors')

  const setErrors = (newErrors) => {
    errors.value = newErrors
  }

  const resetErrors = () => {
    setErrors({})
    setStatus(null)
  }

  const setStatus = (message) => {
    statusMessage.value = message
  }

  const setIsSaving = (newState) => {
    isSaving.value = newState
  }

  const setStatusToLastSaved = () => {
    const time = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    statusMessage.value = t('slides_editor.status_messages.last_saved', { time })
  }

  return {
    statusMessage,
    setStatus,
    setStatusToLastSaved,
    setIsSaving,
    setErrors,
    resetErrors
  }
}
